import {
  FiPackage,
  FiUser,
  FiTag,
  FiCalendar,
  FiEye,
} from 'react-icons/fi';

const PendingProductsTable = ({
  products,
  onViewDetails,
  formatDate,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              <div className="flex items-center">
                <FiPackage className="h-4 w-4 ml-1" />
                عکس محصول
              </div>
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">نام محصول</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">تأمین‌کننده</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">کد محصول</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">دسته‌بندی</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">برند</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">تاریخ</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">عملیات</th>
          </tr>
        </thead>

        <tbody className="bg-white divide-y divide-gray-200">
          {products.length === 0 ? (
            <tr>
              <td colSpan={8} className="px-6 py-12 text-center text-gray-500">
                <FiPackage className="mx-auto h-12 w-12 text-gray-300 mb-4" />
                <p className="text-lg font-medium">محصولی در انتظار بازرسی وجود ندارد</p>
              </td>
            </tr>
          ) : (
            products.map((product) => (
              <tr key={product.id} className="hover:bg-gray-50">
                {/* عکس */}
                <td className="px-6 py-4">
                  {product.featured_thumbnail_url ? (
                    <img
                      src={product.featured_thumbnail_url}
                      alt={product.name || 'محصول'}
                      className="h-12 w-12 rounded-lg object-cover border"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/100x100';
                        e.target.onerror = null;
                      }}
                    />
                  ) : (
                    <div className="h-12 w-12 bg-gray-100 rounded-lg flex items-center justify-center">
                      <FiPackage className="text-gray-400" />
                    </div>
                  )}
                </td>

                {/* نام */}
                <td className="px-6 py-4">
                  <div className="text-sm font-medium text-gray-900">
                    {product.name || 'بدون نام'}
                  </div>
                </td>

                {/* تامین‌کننده */}
                <td className="px-6 py-4">
                  <div className="flex items-center text-sm">
                    <FiUser className="ml-1 text-gray-400" />
                    {product.supplier_name || 'نامشخص'}
                  </div>
                </td>

                {/* کد */}
                <td className="px-6 py-4 font-mono text-sm">
                  {product.sku || `PRD-${product.id}`}
                </td>

                {/* دسته */}
                <td className="px-6 py-4">
                  <span className="px-3 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                    {product.category_name || 'بدون دسته'}
                  </span>
                </td>

                {/* برند */}
                <td className="px-6 py-4">
                  <span className="px-3 py-1 text-xs rounded-full bg-blue-100 text-blue-800">
                    {product.brand || 'بدون برند'}
                  </span>
                </td>

                {/* تاریخ */}
                <td className="px-6 py-4 text-sm text-gray-500">
                  <FiCalendar className="inline ml-1" />
                  {product.created_at ? formatDate(product.created_at) : 'نامشخص'}
                </td>

                {/* عملیات */}
                <td className="px-6 py-4">
                  <button
                    onClick={() => onViewDetails(product.id)}
                    className="flex items-center text-blue-600 hover:bg-blue-50 p-2 rounded-lg"
                  >
                    <FiEye className="ml-1" />
                    مشاهده
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PendingProductsTable;
